var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 0.235,
    style: {
      fill: "#F5F5F5"
    },
    width: 511.53,
    height: 511.53
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 0.235,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 39.34
  }), /*#__PURE__*/React.createElement("rect", {
    y: 157.63,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 39.34
  }), /*#__PURE__*/React.createElement("rect", {
    y: 78.935,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 39.34
  }), /*#__PURE__*/React.createElement("rect", {
    y: 236.32,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 39.34
  }), /*#__PURE__*/React.createElement("rect", {
    y: 393.71,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 39.34
  }), /*#__PURE__*/React.createElement("rect", {
    y: 472.41,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 39.34
  }), /*#__PURE__*/React.createElement("rect", {
    y: 315.02,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 39.34
  })), /*#__PURE__*/React.createElement("rect", {
    y: 0.235,
    style: {
      fill: "#41479B"
    },
    width: 275.44,
    height: 275.44
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M35.219,20.814l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.624,0.53-1.631l6.708-0.052l2.122-6.364C33.779,19.99,34.945,19.99,35.219,20.814z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M35.219,73.902l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.624,0.53-1.631l6.708-0.052l2.122-6.364C33.779,73.077,34.945,73.077,35.219,73.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M35.219,132.78l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.632l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.625,0.53-1.632l6.708-0.052l2.122-6.364C33.779,131.956,34.945,131.956,35.219,132.78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M35.219,186.876l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.624,0.53-1.631l6.708-0.052l2.122-6.364C33.779,186.052,34.945,186.052,35.219,186.876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M35.219,236.102l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.625,0.53-1.631l6.708-0.052l2.122-6.364C33.779,235.278,34.945,235.278,35.219,236.102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M61.058,45.953l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 L49.98,54c-0.698-0.516-0.339-1.624,0.53-1.631l6.708-0.052l2.122-6.364C59.618,45.129,60.784,45.129,61.058,45.953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M61.058,104.832l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.624,0.53-1.631l6.708-0.052l2.122-6.364C59.618,104.008,60.784,104.008,61.058,104.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M61.058,160.771l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.624,0.53-1.631l6.708-0.052l2.122-6.364C59.618,159.948,60.784,159.948,61.058,160.771z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M61.058,211.007l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.624,0.53-1.631l6.708-0.052l2.122-6.364C59.618,210.182,60.784,210.182,61.058,211.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M86.898,20.814l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.624,0.53-1.631l6.708-0.052l2.122-6.364C85.458,19.99,86.623,19.99,86.898,20.814z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M86.898,73.902l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.624,0.53-1.631l6.708-0.052l2.122-6.364C85.458,73.077,86.623,73.077,86.898,73.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M86.898,132.78l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.632l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.625,0.53-1.632l6.708-0.052l2.122-6.364C85.458,131.956,86.623,131.956,86.898,132.78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M86.898,186.876l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.456-3.902l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.624,0.53-1.631l6.708-0.052l2.122-6.364C85.458,186.052,86.623,186.052,86.898,186.876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M86.898,236.102l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.625,0.53-1.631l6.708-0.052l2.122-6.364C85.458,235.278,86.623,235.278,86.898,236.102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M112.737,45.953l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 L101.659,54c-0.698-0.516-0.339-1.624,0.53-1.631l6.711-0.052l2.122-6.364C111.297,45.129,112.462,45.129,112.737,45.953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M112.737,104.832l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.624,0.53-1.631l6.708-0.052l2.122-6.364C111.297,104.008,112.462,104.008,112.737,104.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M112.737,160.771l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.624,0.53-1.631l6.708-0.052l2.122-6.364C111.297,159.948,112.462,159.948,112.737,160.771z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M112.737,211.007l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.624,0.53-1.631l6.708-0.052l2.122-6.364C111.297,210.182,112.462,210.182,112.737,211.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M138.576,20.814l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.624,0.53-1.631l6.708-0.052l2.122-6.364C137.136,19.99,138.301,19.99,138.576,20.814z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M138.576,73.902l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.624,0.53-1.631l6.708-0.052l2.122-6.364C137.136,73.077,138.301,73.077,138.576,73.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M138.576,132.78l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.632l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.625,0.53-1.632l6.708-0.052l2.122-6.364C137.136,131.956,138.301,131.956,138.576,132.78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M138.576,186.876l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.624,0.53-1.631l6.708-0.052l2.122-6.364C137.136,186.052,138.301,186.052,138.576,186.876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M138.576,236.102l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.625,0.53-1.631l6.708-0.052l2.122-6.364C137.136,235.278,138.301,235.278,138.576,236.102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M164.415,45.953l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 L153.337,54c-0.698-0.516-0.339-1.624,0.529-1.631l6.708-0.052l2.122-6.364C162.975,45.129,164.14,45.129,164.415,45.953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M164.415,104.832l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.624,0.529-1.631l6.708-0.052l2.122-6.364C162.975,104.008,164.14,104.008,164.415,104.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M164.415,160.771l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.624,0.529-1.631l6.708-0.052l2.122-6.364C162.975,159.948,164.14,159.948,164.415,160.771z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M164.415,211.007l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.624,0.529-1.631l6.708-0.052l2.122-6.364C162.975,210.182,164.14,210.182,164.415,211.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M190.254,20.814l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.624,0.53-1.631l6.708-0.052l2.122-6.364C188.814,19.99,189.979,19.99,190.254,20.814z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M190.254,73.902l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.624,0.53-1.631l6.708-0.052l2.122-6.364C188.814,73.077,189.979,73.077,190.254,73.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M190.254,132.78l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.632l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.625,0.53-1.632l6.708-0.052l2.122-6.364C188.814,131.956,189.979,131.956,190.254,132.78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M190.254,186.876l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.624,0.53-1.631l6.708-0.052l2.122-6.364C188.814,186.052,189.979,186.052,190.254,186.876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M190.254,236.102l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.625,0.53-1.631l6.708-0.052l2.122-6.364C188.814,235.278,189.979,235.278,190.254,236.102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M216.094,45.953l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 L205.016,54c-0.698-0.516-0.339-1.624,0.53-1.631l6.708-0.052l2.122-6.364C214.653,45.129,215.819,45.129,216.094,45.953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M216.094,104.832l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.624,0.53-1.631l6.708-0.052l2.122-6.364C214.653,104.008,215.819,104.008,216.094,104.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M216.094,160.771l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.624,0.53-1.631l6.708-0.052l2.122-6.364C214.653,159.948,215.819,159.948,216.094,160.771z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M216.094,211.007l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.624,0.53-1.631l6.708-0.052l2.122-6.364C214.653,210.182,215.819,210.182,216.094,211.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M241.933,20.814l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.624,0.53-1.631l6.708-0.052l2.122-6.364C240.492,19.99,241.658,19.99,241.933,20.814z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M241.933,73.902l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.624,0.53-1.631l6.708-0.052l2.122-6.364C240.492,73.077,241.658,73.077,241.933,73.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M241.933,132.78l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.632l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.625,0.53-1.632l6.708-0.052l2.122-6.364C240.492,131.956,241.658,131.956,241.933,132.78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M241.933,186.876l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.624,0.53-1.631l6.708-0.052l2.122-6.364C240.492,186.052,241.658,186.052,241.933,186.876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M241.933,236.102l2.122,6.364l6.708,0.052c0.868,0.007,1.229,1.115,0.53,1.631l-5.396,3.985 l2.023,6.396c0.262,0.828-0.68,1.513-1.388,1.008l-5.458-3.901l-5.458,3.901c-0.706,0.506-1.649-0.18-1.388-1.008l2.023-6.396 l-5.396-3.985c-0.698-0.516-0.339-1.625,0.53-1.631l6.708-0.052l2.122-6.364C240.492,235.278,241.658,235.278,241.933,236.102z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/us.32c036a7edc8a389a763a3782960d0d5.svg";
export { ForwardRef as ReactComponent };